import { Tr as ChakraTableRow, Td as ChakraTableCell, Box } from '@chakra-ui/react';
import { useMultiStyleConfig } from '@chakra-ui/system';
import React from 'react';

import { useTableExperimentalContext } from './TableExperimentalContext';

import { Spinner } from 'atoms';

const TableLoading = (): React.ReactElement | null => {
  const tableContext = useTableExperimentalContext();
  const { reactTable, isFetching } = tableContext;

  const themeStyles = useMultiStyleConfig('TableExperimental', { ...tableContext, disableRowHoverStyle: true });

  if (!isFetching) {
    return null;
  }

  const columns = reactTable.getAllColumns();

  return (
    <ChakraTableRow sx={themeStyles.loading}>
      <ChakraTableCell aria-busy="true" colSpan={columns.length}>
        <Box display="flex" justifyContent="center">
          <Spinner size="sm" />
        </Box>
      </ChakraTableCell>
    </ChakraTableRow>
  );
};

export default TableLoading;
